import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { massUnitField, refrigerantNameField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { msg } from '@lingui/core/macro';

export const refrigerantsMetadata = {
  displayName: msg({
    message: 'Refrigerants',
    context: 'Activity data schema name for refrigerants',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...productFields,
    ...buildingCommonFields,
    ...buildingRevisionFields,
    quantity: {
      displayName: msg({
        message: 'Refrigerant leakage',
        context: 'The leakage of refrigerants.',
      }),
      externalDescription: msg({
        message: 'The leakage of refrigerants.',
        context: 'Refrigerant leakage',
      }),
    },
    refrigerant_leakage_source: {
      displayName: msg({
        message: 'Refrigerant leakage source',
        context:
          'Whether the refrigerant gas leakage comes from manufacturing or installed equipment.',
      }),
      externalDescription: msg({
        message: 'The source of the refrigerant gas leakage.',
        context: 'Refrigerant leakage source',
      }),
    },
    refrigerant_name: refrigerantNameField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
